import { ToastContainer as Container } from 'react-toastify';
import styled from 'styled-components';
import { ToastContainerStyles } from './styles';

export const ToastContainer = styled(Container)`
  ${ToastContainerStyles}
`;
